import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { motion } from "framer-motion";
import imgAnim from "../../../assets/img/img-animations/images-anim";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import "../../../assets/css/tableprogramme.css";

const buttonVariants = {
  hover: {
    // scale: [1, 1.2, 1, 1.2, 1, 1.2, 1, 1.2, 1, 1.2, 1],
    scale: 1.02,
    textShadow: "0 0 8px rgb(255, 255, 255)",
  },
};

const Animations = () => {
  return (
    <main role="main" className="mc-fond-ecran">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          {imgAnim.map((anim) => {
            return (
              <Col xs={12} sm={6} md={4} lg={3} key={anim.id}>
                <Nav>
                  <NavLink className="text-center" to={anim.path}>
                    <motion.div
                      className="text-light fw-semibold"
                      variants={buttonVariants}
                      whileHover="hover"
                    >
                      <Card className="m-2 text-light">
                        <Card.Img
                          src={anim.img}
                          alt={"Image animation"}
                          className="img-fluid border border-2 border-primary"
                        />
                        <Card.ImgOverlay>
                          <Card.Title className="bg-secondary mc-rfs-5">
                            {anim.title}
                          </Card.Title>
                          <Card.Text className="bg-dark-subtle px-2 mc-rfs-6 text-dark">
                            {anim.subTitle}
                          </Card.Text>
                        </Card.ImgOverlay>
                      </Card>
                    </motion.div>
                  </NavLink>
                </Nav>
              </Col>
            );
          })}
        </Row>
      </Container>
    </main>
  );
};

export default Animations;
